import React from 'react';
import Tabs from '../../tabs';
import Detail from './list_domestic';

export default ({data, id, direction}) => {
    return (
        <div style={{display:'flex', flexDirection:'column'}}>
            <Tabs 
                selTab={2}
                tabs={[
                    {
                        id:0,
                        caption:'detail',
                        href:`/flight/domestic/${id}`,
                    },
                    {
                        id:1,
                        caption:'pnr',
                        href:`/flight/domestic/pnr/${id}`,
                    },
                    {
                        id:2, 
                        caption:'passengers',
                        href:`/flight/domestic/passengers/${id}`,
                    }
                ]}
            />
            <Detail data={data}  />
        </div>
    )
}